import PropTypes from "prop-types"
import React, { useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/true_ESP_logo.png"
import { base_url, router } from "utils/APIUrls"

const Login = props => {
  const [password, setPassword] = useState("")
  const [email, setEmail] = useState("")
  const navigate = useNavigate()

  var handleSubmit = e => {
    e.preventDefault()
    const reqObj = {
      email: email,
      password: password,
    }
    axios
      .post(base_url + router.admin_login, reqObj)
      .then(res => {
        console.log("check token...",res.data)
        localStorage.setItem("authorizedToken", res.data.token)
        localStorage.setItem("firstname", res.data.data.firstname)

        toast.success(res.data.msg || "OTP Verified Successfully")
        // console.log("Login Details...",res.data.data)

        navigate("/")
      })
      .catch(err => {
        if (err?.response?.data?.errors) {
          err?.response?.data?.errors.forEach(error => {
            console.log(error.msg)

            toast.error(error.msg)
          })
        } else {
          toast.error(err?.response?.data?.message || "An error occured")
        }
      })
  }

  return (
    <React.Fragment>
      <ToastContainer />

      <div
        className="account-pages my-5 pt-sm-5 vh-90 d-flex align-items-center"
        style={{ minHeight: "85vh" }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h4 className="text-primary">Sign In</h4>
                        <p>Sign in to continue to True-ESP.</p>
                      </div>
                    </Col>
                    <Col className="col-5 d-flex justify-content-center align-items-center py-2">
                      <img
                        src={logo}
                        alt="Company Logo"
                        className="w-75"
                        style={{
                          maxWidth: "100px",
                          height: "auto",
                          borderRadius: "5px",
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    {/* <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="68"
                          />
                        </span>
                      </div>
                    </Link> */}
                  </div>
                  <div className="p-2">
                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email"
                          type="text"
                          onChange={e => setEmail(e.target.value)}
                        />
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          className="form-control"
                          placeholder="Enter Password"
                          type="text"
                          onChange={e => setPassword(e.target.value)}
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                          >
                            SIGN IN
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-2 text-center"></div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
